import React from 'react'

export default function Lsb() {
  return (
        <div className="left-sidebar">
            <div className="sidebar-header d-flex align-items-center justify-content-start">
                <img src="./assets/images/logo.png" alt="Logo"/>
                <h2>Sabino Velásquez</h2>
                
            </div>
            <img className="me" src="./assets/images/me.png" alt="Sabino"/>
            {/* <h2 className="email">hi (at) sabino.cl</h2> */}
            <p><span className="designation ">Tech Lead | Founder @ Fuix</span><br/><small>Making ideas happen with code</small></p>
            {/* <p className="copyright">&copy; 2023</p> */}
            <ul className="social-profile d-flex align-items-center flex-wrap justify-content-center">
                {/* <li>
                    <a href="https://twitter.com/"><i className="lab la-twitter"></i></a>
                </li> */}
                <li>
                    <a href="https://www.linkedin.com/in/sabinov/" target="_blank" rel="noreferrer"><i className="lab la-linkedin-in"></i></a>
                </li>
                <li>
                    <a href="https://github.com/sabinovelasquez" target="_blank" rel="noreferrer"><i className="lab la-github"></i></a>
                </li>
                <li>
                    <a href="https://www.youtube.com/@sabinovelasquez" target="_blank" rel="noreferrer"><i className="lab la-youtube"></i></a>
                </li>
            </ul>
            <a href="https://calendly.com/sabino_vl/30min" target="_blank" rel="noreferrer" className="theme-btn">
                <i className="las la-calendar-day"></i> Let's talk!
            </a>
            <p className='text-center mt-2'>
                <a className="small text-warning" href="mailto:hi@sabino.cl" target="_blank" rel="noreferrer">
                    <i className="las la-envelope"></i> hi@sabino.cl 
                </a>
            </p>
        </div>
  )
}   
